// 即日発送締め切り時間
  const limitHour = 12;
  const displayHour = 11;
  // 休日 (日付)
  const holidayDate = [
    "2023/1/1", //元日
    "2023/1/2",
    "2023/1/3",
    "2023/1/9", //成人の日
    "2023/2/11", //建国記念の日
    "2023/2/23", //天皇誕生日
    "2023/3/21", //春分の日
    "2023/4/29", //昭和の日
    "2023/5/3", //憲法記念日
    "2023/5/4", //みどりの日
    "2023/5/5", //こどもの日
    "2023/7/17", //海の日
    "2023/8/11", //山の日
    "2023/8/12", //夏季休業
    "2023/8/13", //夏季休業
    "2023/8/14", //夏季休業
    "2023/8/15", //夏季休業
    "2023/9/18", //敬老の日
    "2023/9/23", //秋分の日
    "2023/10/9", //スポーツの日
    "2023/11/3", //文化の日
    "2023/11/23", //勤労感謝の日
  ];
  // 休日 (曜日)
  const holidayWeek = ["土", "日"];
  // 定休日を格納する
  let shipDate = null;
  // ベースとなる日 (=今日)
  const baseDate = new Date();
  const nowDate = new Date();
  const nextDate = new Date();

  //基準
  const baseDate01 = new Date();
  const nextDate01 = new Date();
  
  console.log("基準日:" + baseDate01);

  // 現在時刻
  const hours = baseDate.getHours();
  var loop = 1;
  // 営業日 && 12時までの注文は当日出荷
  //console.log("isHoliday - nextDate01");
  //console.log(!isHoliday(nextDate01));

  if (!isHoliday(baseDate01) && hours < limitHour) {
    //12時までの注文
    //12時までの受け付けは翌日
    //console.log("ifの方");
    // 定休日を算出する
    var Week = ["日", "月", "火", "水", "木", "金", "土"][nowDate.getDay()];

    do {
        //nowDate.setDate(nowDate.getDate() + 1); 平日に注文日時がずれる
        nextDate01.setDate(nextDate01.getDate() + 0);
        console.log("isHoliday:"+!isHoliday(nextDate01));
        if (!isHoliday(nextDate01)) {
            shipDate = nextDate01
        }
        if( loop > 20){
            break;
        }
        var loop = loop + 1;
        console.log("ループ回数:"+loop);
    }while (shipDate === null);

    //console.log("nowDate:"+nowDate);

   // 休日でない場合
   var Week = ["日", "月", "火", "水", "木", "金", "土"][nowDate.getDay()];
   //console.log("do while 抜け:" + Week);
   if( Week == "金" || Week == "土" || Week == "日" ){
    //shipDate.setDate(shipDate.getDate() + 1);
   }

   const NowWeek = ["日", "月", "火", "水", "木", "金", "土"][nowDate.getDay()];
   if( NowWeek == "日" ){
    nowDate.setDate(nowDate.getDate() + 1);
   }
   //console.log("nowDate:"+nowDate);
   //console.log("!isHoliday(nowDate):"+!isHoliday(nowDate));

   if (!isHoliday(nowDate)) {

   }

  }else{
    //12時以降の注文
    console.log("elseの方");
    var do_loop = 1
    //console.log("nowDate:"+nowDate);
    //console.log("!isHoliday(nowDate):"+!isHoliday(nowDate));
    nowDate.setDate(nowDate.getDate() + 1);
    /*
    console.log("nowDate 翌日:"+nowDate);
    console.log("!isHoliday(nowDate):"+!isHoliday(nowDate));
    console.log("nextDate01:"+nextDate01);
    console.log("!isHoliday(nextDate01):"+!isHoliday(nextDate01));
    console.log("baseDate01:"+baseDate01);
    console.log("!isHoliday(baseDate01):"+!isHoliday(baseDate01));
    */
    do {
        if(isHoliday(nowDate)){
            nowDate.setDate(nowDate.getDate() + 1);
        }
        if(do_loop == 1){
            nextDate01.setDate(nextDate01.getDate() + 1);
        }else{
            nextDate01.setDate(nextDate01.getDate() + 1);
        }
        console.log("nextDate01: do whileの中:"+nextDate01);
        if (!isHoliday(nextDate01)) {
            shipDate = nextDate01
        }
        if( loop > 20){
            break;
        }
        var loop = loop + 1;
        var do_loop = do_loop + 1;
    }while (shipDate === null);
    //shipDate.setDate(shipDate.getDate() + 2);
    /*
    console.log("shipDate");
    console.log(shipDate);
    console.log("nowDate");
    console.log(nowDate);
    const Week = ["日", "月", "火", "水", "木", "金", "土"][baseDate01.getDay()];
    console.log("do while 抜けた後: " + Week);
    */
    if(Week == "金" || Week == "土"){
        //注文した曜日が金曜日の場合
        nextDate01.setDate(nextDate01.getDate() + 1);
    }

    //console.log("nowDate:"+nowDate);
 

    
  }
    // 休日でない場合
  //console.log("配送日設定抜け - shipDate");
  //console.log(shipDate);

  if (shipDate !== null) {
    // 注文日時
    // 年度を出す場合
    //document.getElementById('shipDate01').innerText = formatDate(shipDate, 'MM月DD日')
    //document.getElementById('shipDate01').innerText = formatDate(shipDate, 'MM/DD')+" AM"+displayHour+":59"

    // 出荷日をHTMLに反映
    // 年度を出す場合
    //document.getElementById('shipDate02').innerText = formatDate(shipDate02, 'MM/DD')
    //document.getElementById('shipDate02').innerText = formatDate(shipDate, 'MM月DD日')

    if (document.getElementById("shipDate03") != null) {
      document.getElementById("shipDate03").innerText = formatDate(nowDate,"MM月DD日");
      document.getElementById("shipDate03").innerText = formatDate(nowDate, "MM/DD") + " AM" + displayHour + ":59";
    }
    if (document.getElementById("shipDate04") != null) {
      //document.getElementById('shipDate04').innerText = formatDate(shipDate, 'MM月DD日')
      document.getElementById("shipDate04").innerText = formatDate(shipDate,"MM月DD日");
    }

    //document.getElementById('shipDate04').innerText = formatDate(shipDate02, 'MM/DD')
  }

  /**
   * 今日が週末(金～日)かどうか判定する
   * @return boolean
   */

  /**
   * 休日かどうか判定する
   * @return boolean
   */
  function isHoliday(date) {
    const week = date.getDay();
    const weekString = ["日", "月", "火", "水", "木", "金", "土"][week];
    return (
      holidayDate.includes(formatDate(date, "YYYY/MM/DD")) ||
      holidayWeek.includes(weekString)
    );
  }

  /**
   * 日付をフォーマットする
   * @param date
   * @param format
   * @returns {*}
   */
  function formatDate(date, format) {
    format = format.replace(/YYYY/, date.getFullYear());
    format = format.replace(/MM/, date.getMonth() + 1);
    format = format.replace(/DD/, date.getDate());
    return format;
  }